import DeliveriesController from 'cio/controllers/deliveries';

export default class TransactionalMessageOverviewSentController extends DeliveriesController {
  filterQueryParams = ['action', 'recipient'];
  queryParams = ['actionType', 'action', 'recipient', 'deliveryStatus', 'startTs', 'endTs'];
  detailRoute = 'transactional.message.overview.sent.delivery';

  icon = 'transactional-api';
}
